module.exports = __webpack_public_path__ + "static/media/Knezi_hora.99df43d2.md";